module.exports = __webpack_public_path__ + "static/media/yt-api.ceeeabb8.jpg";